// @flow
import React, { useCallback } from 'react';
import FormSubmitAction from '..';
import { ACTION_SUBMIT } from '../../form-submitter-context/form-submitter-constant';
import { useFormSubmitterContext } from '../../form-submitter-context';

const FormSubmitActionWithContext = () => {
  const { state, dispatch } = useFormSubmitterContext();
  const {
    submitInProgress,
    submissionFailed,
    isPreview,
    isAuthenticationRequired,
  } = state;
  const onSubmit = useCallback(() => {
    dispatch({
      type: ACTION_SUBMIT,
    });
  }, [dispatch]);

  return (
    <FormSubmitAction
      isAuthenticationRequired={isAuthenticationRequired}
      isDisabled={isPreview}
      onSubmit={onSubmit}
      submissionFailed={submissionFailed}
      submitInProgress={submitInProgress}
    />
  );
};

export { FormSubmitActionWithContext };
export default FormSubmitActionWithContext;
